import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { StravaProvider } from './context/StravaContext'
import HomePage from './pages/HomePage'
import AdminPage from './pages/AdminPage'
import StravaCallbackPage from './pages/StravaCallbackPage'
import OAuthCodePage from './pages/OAuthCodePage'

function App() {
  return (
    <AuthProvider>
      <StravaProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/auth/strava/callback" element={<StravaCallbackPage />} />
            <Route path="/oauth/code" element={<OAuthCodePage />} />
          </Routes>
        </Router>
      </StravaProvider>
    </AuthProvider>
  )
}

export default App